// extracted by mini-css-extract-plugin
export default {"splash_screen":"SplashScreen_splash_screen__-NlNX","splash_screen_container":"SplashScreen_splash_screen_container__jtpHO"};